import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useWidgetSelector } from "../../../store/store";
import { State } from "../../../store/state";
import { PaymentMethod } from "../../../types/Enums";
import { AvtaleGiroPaymentMethod, BankPaymentMethod, VippsPaymentMethod, WidgetPane3ReferralsProps, WidgetProps } from "../../../types/WidgetProps";
import { VippsPane } from "./Vipps/VippsPane";
import { AvtaleGiroPane } from "./AvtaleGiro/AvtaleGiroPane";
import { BankPane } from "./Bank/BankPane";
import { QuickPayPane } from "./QuickPay/QuickPay";
import { DKBankPane } from "./DKBank/DKBank";
export const PaymentPane: React.FC<{
  referrals: WidgetPane3ReferralsProps;
  paymentMethods: NonNullable<WidgetProps["methods"]>;
}> = t0 => {
  const $ = _c(30);
  const {
    referrals,
    paymentMethods
  } = t0;
  const method = useWidgetSelector(_temp);
  switch (method) {
    case PaymentMethod.BANK:
      {
        let t1;
        if ($[0] !== paymentMethods) {
          t1 = paymentMethods.find(_temp2);
          $[0] = paymentMethods;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        const bankConfiguration = t1;
        if (!bankConfiguration) {
          throw new Error("Missing configuration for bank, but selected payment method is bank");
        }
        let t2;
        if ($[2] !== bankConfiguration || $[3] !== referrals) {
          t2 = <BankPane config={bankConfiguration} referrals={referrals} />;
          $[2] = bankConfiguration;
          $[3] = referrals;
          $[4] = t2;
        } else {
          t2 = $[4];
        }
        return t2;
      }
    case PaymentMethod.VIPPS:
      {
        let t1;
        if ($[5] !== paymentMethods) {
          t1 = paymentMethods.find(_temp3);
          $[5] = paymentMethods;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        const vippsConfiguration = t1;
        if (!vippsConfiguration) {
          throw new Error("Missing configuration for Vipps, but selected payment method is vipps");
        }
        let t2;
        if ($[7] !== referrals || $[8] !== vippsConfiguration) {
          t2 = <VippsPane config={vippsConfiguration} referrals={referrals} />;
          $[7] = referrals;
          $[8] = vippsConfiguration;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        return t2;
      }
    case PaymentMethod.AVTALEGIRO:
      {
        let t1;
        if ($[10] !== paymentMethods) {
          t1 = paymentMethods.find(_temp4);
          $[10] = paymentMethods;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        const avtaleGiroConfiguration = t1;
        if (!avtaleGiroConfiguration) {
          throw new Error("Missing configuration for AvtaleGiro, but selected payment method is avtalegiro");
        }
        let t2;
        if ($[12] !== avtaleGiroConfiguration || $[13] !== referrals) {
          t2 = <AvtaleGiroPane config={avtaleGiroConfiguration} referrals={referrals} />;
          $[12] = avtaleGiroConfiguration;
          $[13] = referrals;
          $[14] = t2;
        } else {
          t2 = $[14];
        }
        return t2;
      }
    case PaymentMethod.QUICKPACK_MOBILEPAY:
      {
        let t1;
        if ($[15] !== paymentMethods) {
          t1 = paymentMethods.find(_temp5);
          $[15] = paymentMethods;
          $[16] = t1;
        } else {
          t1 = $[16];
        }
        const quickpayConfiguration_0 = t1;
        if (!quickpayConfiguration_0) {
          throw new Error("Missing configuration for QuickPay, but selected payment method is quickpay");
        }
        let t2;
        if ($[17] !== quickpayConfiguration_0 || $[18] !== referrals) {
          t2 = <QuickPayPane config={quickpayConfiguration_0} referrals={referrals} />;
          $[17] = quickpayConfiguration_0;
          $[18] = referrals;
          $[19] = t2;
        } else {
          t2 = $[19];
        }
        return t2;
      }
    case PaymentMethod.QUICKPAY_CARD:
      {
        let t1;
        if ($[20] !== paymentMethods) {
          t1 = paymentMethods.find(_temp6);
          $[20] = paymentMethods;
          $[21] = t1;
        } else {
          t1 = $[21];
        }
        const quickpayConfiguration = t1;
        if (!quickpayConfiguration) {
          throw new Error("Missing configuration for QuickPay, but selected payment method is quickpay");
        }
        let t2;
        if ($[22] !== quickpayConfiguration || $[23] !== referrals) {
          t2 = <QuickPayPane config={quickpayConfiguration} referrals={referrals} />;
          $[22] = quickpayConfiguration;
          $[23] = referrals;
          $[24] = t2;
        } else {
          t2 = $[24];
        }
        return t2;
      }
    case PaymentMethod.DKBANK:
      {
        let t1;
        if ($[25] !== paymentMethods) {
          t1 = paymentMethods.find(_temp7);
          $[25] = paymentMethods;
          $[26] = t1;
        } else {
          t1 = $[26];
        }
        const dkbankConfiguration = t1;
        if (!dkbankConfiguration) {
          throw new Error("Missing configuration for DK Bank, but selected payment method is dkbank");
        }
        let t2;
        if ($[27] !== dkbankConfiguration || $[28] !== referrals) {
          t2 = <DKBankPane config={dkbankConfiguration} referrals={referrals} />;
          $[27] = dkbankConfiguration;
          $[28] = referrals;
          $[29] = t2;
        } else {
          t2 = $[29];
        }
        return t2;
      }
    default:
      {
        throw new Error(`Unknown payment method: ${method}`);
      }
  }
};
function _temp(state) {
  return state.donation.method;
}
function _temp2(method_5) {
  return method_5._id === "bank";
}
function _temp3(method_4) {
  return method_4._id === "vipps";
}
function _temp4(method_3) {
  return method_3._id === "avtalegiro";
}
function _temp5(method_2) {
  return method_2._id === "quickpay_mobilepay";
}
function _temp6(method_1) {
  return method_1._id === "quickpay_card";
}
function _temp7(method_0) {
  return method_0._id === "dkbank";
}